import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  user:string;
  view:boolean;
  user_name:string;
  user_photo:string;
  user_ob:any;
  user_role:string;
  constructor(private  router:Router){
    this.user=localStorage.getItem('user_id');
     if(this.user){
       this.view=true;            
       this.user_ob= JSON.parse(localStorage.getItem('user'));
       this.user_role=localStorage.getItem('userRole');

       if(this.user_ob){
       this.user_name=this.user_ob.user_name;
       this.user_photo=this.user_ob.user_photo;}
     }
     else {
       this.view=false;
       console.log(this.view);
     }
  }

  ngOnInit() {
  }

  logout(){
    localStorage.clear();
    this.router.navigate(['/login']);

  }

}




// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/header/header.component.ts